'use client';

import { FC, useState } from 'react';
import { ImageWrapper } from './styles';

type BrokerAvatarProps = {
  src: string;
  alt?: string;
};

export const BrokerAvatar: FC<BrokerAvatarProps> = ({ src, alt = '' }) => {
  const [visible, setVisible] = useState(false);

  return (
    <ImageWrapper style={{ display: visible ? undefined : 'none' }}>
      <img src={src} alt={alt} onLoad={() => setVisible(true)} onError={() => setVisible(false)} />
    </ImageWrapper>
  );
};
